import PropTypes from 'prop-types'
import React from 'react'
import classes from './ViewBody.module.scss'

export class ViewBody extends React.Component {
  static propTypes = {
    className: PropTypes.string
  }

  render () {
    const {
      children,

      className,

      ...props
    } = this.props

    let compClassName = classes.body
    if (className) compClassName += ' ' + className

    return (
      <div
        {...props}
        className={compClassName}
      >
        {children}
      </div>
    )
  }
}

export default ViewBody

